import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';

class InviteFriend extends Component {
  static propTypes = {
    member: PropTypes.shape({}),
    socProvider: PropTypes.string,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {
    member: {},
    socProvider: null,
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  inviteFriend = () => {
    window.FB.ui({
      method: 'apprequests',
      message: 'Come Play Zole',
    }, () => {
    });
  }

  render() {
    const { t, socProvider } = this.props;

    return (
      <Fragment>
        {socProvider === 'facebook' && (
          <Row>
            <Col xs="4">
              <Button color="link" className="send-money-block-invite-button" onClick={this.inviteFriend}>
                {t('sendMoney.inviteFriend')}
              </Button>
            </Col>
          </Row>
        )}
      </Fragment>
    );
  }
}


export default withTranslation('common')(InviteFriend);
